<template>
  <div>
    <vs-popup :title="$t('Province')" :active.sync="showModal">
      <form>
        <div>
          <label class="vs-select--label my-1">{{ $t("NameCountry") }}</label>
          <v-select
            label="name"
            :options="allCountries"
            name="country"
            :reduce="(x) => ({ countryId: x.id, countryName: x.name })"
            v-validate="{ required: 'true' }"
            ref="countryListSelect"
            v-model="ProvinceForModify.parentId"
            :clearable="false"
            dir="rtl"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('country')">{{
            errors.first("country")
          }}</span>
        </div>
        <div>
          <vs-input
            class="inputx mb-3 mt-3"
            v-model="ProvinceForModify.name"
            :label="$t('ProvinceName')"
            name="ProvinceName"
            v-validate="{ required: 'true' }"
          />
          <span class="text-danger text-sm" v-show="errors.has('ProvinceName')">{{
            errors.first("ProvinceName")
          }}</span>
        </div>

        <div class="w-full mt-3">
          <vs-input
            class="inputx mb-3"
            v-model="ProvinceForModify.priority"
            :label="$t('Priority')"
            name="priority"
            v-validate="{ required: 'true' }"
          />
          <span class="text-danger text-sm" v-show="errors.has('Priority')">{{
            errors.first("Priority")
          }}</span>
        </div>

        <vs-button
          type="filled"
          class="float-right my-4"
          @click.prevent="submitForm"
          :disabled="disabled"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
const dict = {
  custom: {
    ProvinceName: {
      required: "لطفا نام استان را وارد نمایید.",
    },
    Priority: {
      required: "لطفا اولویت را وارد نمایید.",
    },
    country: {
      required: "لطفا نام کشور را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "",
  props: {
    show: { default: false },
    ProvinceForModify: {}
  },
  components: {
    "v-select": vSelect,
  },  data() {
    return {
      model: {},
      disabled: false
    };
  },
  computed: {
    ...mapGetters({
      allProvinces: "country/provincesByIdList",
      allCities: "country/cityList",
      allCountries: "country/countryList",
    }),
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },
  mounted() {
    this.fetchProvinces();
    this.fetchCountry();
  },
  methods: {
    ...mapActions({
      modifyProvince: "country/modifyProvince",
      fetchProvinces: "country/fetchProvinces",
      fetchCitiesById: "country/fetchCitiesById",
      fetchCountry: "country/fetchCountry",
    }),
    selectProvince(province) {
      this.fetchCitiesById(province.provinceId);
      if (this.$refs.cityListSelect) {
        this.$refs.cityListSelect[0].clearSelection();
      }
    },
    submitForm() {
      this.$validator.validateAll().then(r => {
        if (r) {
          if(this.ProvinceForModify.parentId.countryId){
          this.ProvinceForModify.parentId = this.ProvinceForModify.parentId.countryId;

        }
        else{
          this.ProvinceForModify.parentId = this.ProvinceForModify.parentId.id;

        }
          this.modifyProvince(this.ProvinceForModify).then(() => {
            this.disabled = false;
            this.$emit("finish");
            this.model = {};
          });
        } else {
          this.$swal({
            position: "center-center",
            type: "warning",
            text: "خطا در ثبت مقادیر وارده شده",
            showConfirmButton: false,
            timer: 2000
          });
        }
      });
    }
  }
};
</script>
